document.addEventListener(
  'DOMContentLoaded',
  () => {
    document.querySelectorAll('.sec-ImageText_Video-icon').forEach(button => {
      button.addEventListener('click', () => {
        let video = ''
        if (button.classList[1] === 'sec-ImageText_Video-desktop') {
          video = button.parentNode.querySelector('video.sec-ImageText_Video')
          button.remove()

          button.classList.remove('sec-ImageText_Video-controls')
        }

        video.play()
        video.setAttribute('controls', true)
      })
    })
  },
  false,
)
